





























































































import { Vue, Component } from "vue-property-decorator";
import session from "@/services/SessionService";
import SnackBar from "@/components/Snackbar.vue";
import PasswordChangeAlert from "@/components/PasswordChangeAlert.vue";

@Component({
  name: "App",
  components: {
    SnackBar,
    PasswordChangeAlert
  }
})
export default class App extends Vue {
  session = session;
}
